export default __webpack_public_path__ + "static/media/Amex.c741c506.svg";